import * as Backbone from "backbone";
import * as _ from "lodash";

export class User extends Backbone.Model {

    urlRoot = '/api/v1/users';

    isSensewareAdmin() {
        return _.has(this.get('usergroups'), '2')
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/models/User.ts